import React, { useState,useRef, useEffect } from 'react'
import { postSubirArchivosVigilanciaEpidemilogica } from '../../../services/ControlEnfermeria';
import { fechaActual } from '../../../hooks/UseDate';
import config from "../../../config";

const ModalSubirYDescargarAchivos = ({setmodalOnSubirYDescargarAchivos, dataUser, setactualizarDataVigilacia}) => {
    //const [file, setFile] = useState(null);
    //const [progress, setProgress] = useState(0);
    const handleCancelarClick=()=>{
        setmodalOnSubirYDescargarAchivos(false)
    }
    
    
  //   const [files, setFiles] = useState([]);
  // const [error, setError] = useState('');
  // const fileInputRef = useRef(null);

  // const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
  // const maxSize = 5 * 1024 * 1024; // 5 MB

  // const handleFileChange = (e) => {
  //   const selectedFiles = Array.from(e.target.files);
  //   const validFiles = selectedFiles.filter(file => allowedTypes.includes(file.type) && file.size <= maxSize);

  //   if (validFiles.length !== selectedFiles.length) {
  //     setError('Solo se pueden subir archivos PDF o imágenes que no pesen más de 5 MB');
  //   } else {
  //     setError('');
  //   }

  //   validFiles.forEach((file) => {
  //     setFiles((prevFiles) => [...prevFiles, { file, progress: 0, status: 'pending' }]);
  //   });
  // };

  // const handleDragOver = (e) => {
  //   e.preventDefault();
  // };

  // const handleDrop = (e) => {
  //   e.preventDefault();
  //   const droppedFiles = Array.from(e.dataTransfer.files);
  //   const validFiles = droppedFiles.filter(file => allowedTypes.includes(file.type) && file.size <= maxSize);

  //   if (validFiles.length !== droppedFiles.length) {
  //     setError('Solo se pueden subir archivos PDF o imágenes que no pesen más de 5 MB');
  //   } else {
  //     setError('');
  //   }

  //   validFiles.forEach((file) => {
  //     setFiles((prevFiles) => [...prevFiles, { file, progress: 0, status: 'pending' }]);
  //   });
  // };

  // const uploadFiles = () => {
  //   files.forEach(fileObj => {
  //     if (fileObj.status === 'pending') {
  //       uploadFile(fileObj.file);
  //     }
  //   });
  // };

  // const uploadFile = (file) => {
  //   const formData = new FormData();
  //   formData.append('file', file);

  //   const xhr = new XMLHttpRequest();
  //   xhr.open('POST', `${process.env.REACT_APP_API_URL}/api/cirugias/epideomologica/subir/${file.name}`);
  //   xhr.upload.onprogress = (e) => {
  //     if (e.lengthComputable) {
  //       const percentage = Math.round((e.loaded * 100) / e.total);
  //       setFiles((prevFiles) =>
  //         prevFiles.map((f) =>
  //           f.file === file ? { ...f, progress: percentage, status: 'uploading' } : f
  //         )
  //       );
  //     }
  //   };
  //   xhr.onload = () => {
  //     setFiles((prevFiles) =>
  //       prevFiles.map((f) =>
  //         f.file === file
  //           ? { ...f, status: xhr.status === 200 ? 'completed' : 'failed' }
  //           : f
  //       )
  //     );
  //   };
  //   xhr.onerror = () => {
  //     setFiles((prevFiles) =>
  //       prevFiles.map((f) =>
  //         f.file === file ? { ...f, status: 'failed' } : f
  //       )
  //     );
  //   };
  //   xhr.send(formData);
  // };

  // const getFileTypeIcon = (fileType) => {
  //   if (!fileType) return null;
  //   if (fileType.includes('pdf')) {
  //     return (
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         className="h-6 w-6 text-red-500"
  //         viewBox="0 0 20 20"
  //         fill="currentColor"
  //       >
  //         <path
  //           fillRule="evenodd"
  //           d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H4zm3 12a1 1 0 100-2 1 1 0 000 2zm1-7V3.5L14.5 9H9a1 1 0 01-1-1z"
  //           clipRule="evenodd"
  //         />
  //       </svg>
  //     );
  //   }
  //   if (fileType.includes('png') || fileType.includes('jpeg')) {
  //     return (
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         className="h-6 w-6 text-blue-500"
  //         viewBox="0 0 20 20"
  //         fill="currentColor"
  //       >
  //         <path
  //           fillRule="evenodd"
  //           d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H4zm3 12a1 1 0 100-2 1 1 0 000 2zm1-7V3.5L14.5 9H9a1 1 0 01-1-1z"
  //           clipRule="evenodd"
  //         />
  //       </svg>
  //     );
  //   }
  //   return null;
  // };


  //222
  // const [file, setFile] = useState(null);
  // const [error, setError] = useState('');
  // const fileInputRef = useRef(null);

  // const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
  // const maxSize = 5 * 1024 * 1024; // 5 MB

  // const handleFileChange = (e) => {
  //   const selectedFile = e.target.files[0];

  //   if (selectedFile && (!allowedTypes.includes(selectedFile.type) || selectedFile.size > maxSize)) {
  //     setError('Solo se pueden subir archivos PDF o imágenes que no pesen más de 5 MB');
  //     return;
  //   }

  //   if (file) {
  //     setError('Solo se puede subir un archivo a la vez');
  //     return;
  //   }

  //   setError('');
  //   setFile({ file: selectedFile, progress: 0, status: 'pending' });
  // };

  // const handleDragOver = (e) => {
  //   e.preventDefault();
  // };

  // const handleDrop = (e) => {
  //   e.preventDefault();
  //   const droppedFile = e.dataTransfer.files[0];

  //   if (droppedFile && (!allowedTypes.includes(droppedFile.type) || droppedFile.size > maxSize)) {
  //     setError('Solo se pueden subir archivos PDF o imágenes que no pesen más de 5 MB');
  //     return;
  //   }

  //   if (file) {
  //     setError('Solo se puede subir un archivo a la vez');
  //     return;
  //   }

  //   setError('');
  //   setFile({ file: droppedFile, progress: 0, status: 'pending' });
  // };

  // const uploadFile = () => {
  //   if (!file || file.status !== 'pending') return;

  //   const formData = new FormData();
  //   formData.append('file', file.file);

  //   const xhr = new XMLHttpRequest();
  //   xhr.open('POST', `${process.env.REACT_APP_API_URL}/api/cirugias/epideomologica/subir/${file.file.name}`);
  //   xhr.upload.onprogress = (e) => {
  //     if (e.lengthComputable) {
  //       const percentage = Math.round((e.loaded * 100) / e.total);
  //       setFile((prevFile) => ({
  //         ...prevFile,
  //         progress: percentage,
  //         status: 'uploading',
  //       }));
  //     }
  //   };
  //   xhr.onload = () => {
  //     setFile((prevFile) => ({
  //       ...prevFile,
  //       status: xhr.status === 200 ? 'completed' : 'failed',
  //     }));
  //   };
  //   xhr.onerror = () => {
  //     setFile((prevFile) => ({
  //       ...prevFile,
  //       status: 'failed',
  //     }));
  //   };
  //   xhr.send(formData);
  // };

  // const getFileTypeIcon = (fileType) => {
  //   if (!fileType) return null;
  //   if (fileType.includes('pdf')) {
  //     return (
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         className="h-6 w-6 text-red-500"
  //         viewBox="0 0 20 20"
  //         fill="currentColor"
  //       >
  //         <path
  //           fillRule="evenodd"
  //           d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H4zm3 12a1 1 0 100-2 1 1 0 000 2zm1-7V3.5L14.5 9H9a1 1 0 01-1-1z"
  //           clipRule="evenodd"
  //         />
  //       </svg>
  //     );
  //   }
  //   if (fileType.includes('png') || fileType.includes('jpeg')) {
  //     return (
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         className="h-6 w-6 text-blue-500"
  //         viewBox="0 0 20 20"
  //         fill="currentColor"
  //       >
  //         <path
  //           fillRule="evenodd"
  //           d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H4zm3 12a1 1 0 100-2 1 1 0 000 2zm1-7V3.5L14.5 9H9a1 1 0 01-1-1z"
  //           clipRule="evenodd"
  //         />
  //       </svg>
  //     );
  //   }
  //   return null;
  // };

  //3
  const [file, setFile] = useState(null); // Estado para almacenar el archivo seleccionado
  const [error, setError] = useState('Seleccionar un Archivo'); // Estado para almacenar el mensaje de error
  const fileInputRef = useRef(null); // Referencia al input de tipo file

  const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg']; // Tipos de archivos permitidos
  const maxSize = 5 * 1024 * 1024; // Tamaño máximo del archivo (5 MB)

  // Manejar la selección del archivo
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    // Verificar si el archivo es de tipo permitido y no excede el tamaño máximo
    if (selectedFile && (!allowedTypes.includes(selectedFile.type) || selectedFile.size > maxSize)) {
      setError('Solo se pueden subir archivos PDF o imágenes que no pesen más de 5 MB');
      fileInputRef.current.value = null; // Reset file input
      return;
    }

    // Verificar si ya hay un archivo seleccionado
    if (file) {
      setError('Solo se puede subir un archivo a la vez');
      fileInputRef.current.value = null; // Reset file input
      return;
    }

    setError(''); // Limpiar el mensaje de error
    setFile({ file: selectedFile, progress: 0, status: 'pending' }); // Almacenar el archivo seleccionado
    fileInputRef.current.value = null; // Reset file input
  };

  // Manejar el evento de arrastrar y soltar sobre el área
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Manejar el evento de soltar el archivo
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];

    // Verificar si el archivo es de tipo permitido y no excede el tamaño máximo
    if (droppedFile && (!allowedTypes.includes(droppedFile.type) || droppedFile.size > maxSize)) {
      setError('Solo se pueden subir archivos PDF o imágenes que no pesen más de 5 MB');
      return;
    }

    // Verificar si ya hay un archivo seleccionado
    if (file) {
      setError('Solo se puede subir un archivo a la vez');
      return;
    }

    setError(''); // Limpiar el mensaje de error
    setFile({ file: droppedFile, progress: 0, status: 'pending' }); // Almacenar el archivo seleccionado
  };

  // Simular el progreso de la carga del archivo
  useEffect(() => {
    if (file) {
      const interval = setInterval(() => {
        setFile((prevFile) => {
          if (prevFile.progress >= 100) {
            clearInterval(interval);
            return { ...prevFile, progress: 100 };
          }
          return { ...prevFile, progress: prevFile.progress + 10 };
        });
      }, 100);

      return () => clearInterval(interval);
    }
  }, [file]);

  // Función para subir el archivo
  const uploadFile = () => {
    if(!error || file){
      if (!file || file.status !== 'pending') return;

      const formData = new FormData();
      formData.append('file', file.file);
      // Agregar variables adicionales
      formData.append('codigoDiagnostico', dataUser.MPUdx);
      formData.append('codigoCedula', dataUser.MPUced);
      formData.append('FechaRegistro', fechaActual());

      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${config.API_URL}/api/cirugias/epideomologica/subir/${file.file.name}`);
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const percentage = Math.round((e.loaded * 100) / e.total);
          setFile((prevFile) => ({
            ...prevFile,
            progress: percentage,
            status: 'uploading',
          }));
        }
      };
      xhr.onload = () => {
        setFile((prevFile) => ({
          ...prevFile,
          status: xhr.status === 200 ? 'completed' : 'failed',
        }));
        if (xhr.status === 200) {
          // Cierra el modal solo si la subida fue exitosa
          setactualizarDataVigilacia(formData)
          setmodalOnSubirYDescargarAchivos(false);
        }
      };
      xhr.onerror = () => {
        setFile((prevFile) => ({
          ...prevFile,
          status: 'failed',
        }));
      };
      xhr.send(formData);
      //setactualizarDataVigilacia(formData)
      //setmodalOnSubirYDescargarAchivos(false)
    }
    
  };

  // Obtener el ícono según el tipo de archivo
  const getFileTypeIcon = (fileType) => {
    if (!fileType) return null;
    if (fileType.includes('pdf')) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-red-500"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H4zm3 12a1 1 0 100-2 1 1 0 000 2zm1-7V3.5L14.5 9H9a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </svg>
      );
    }
    if (fileType.includes('png') || fileType.includes('jpeg')) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-blue-500"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H4zm3 12a1 1 0 100-2 1 1 0 000 2zm1-7V3.5L14.5 9H9a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </svg>
      );
    }
    return null;
  };

  const handleClickEliminarArchivo=()=>{
    setFile(null)
    setError('Seleccionar Archivo')
  }

  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Subir PDF o imágenes
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X 
            </button>
          </div>

          {/* <div className="flex flex-col items-center">
      <div
        className="border-dashed border-2 border-gray-400 rounded-lg p-6 text-center cursor-pointer w-80 mb-4"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current.click()}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="hidden"
        />
        <div className="text-blue-500 mb-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 16l-4-4m0 0l4-4m-4 4h18M13 7h4m-2-2v6m0 6v4m0-4h-4m4 0l-4 4m4-4l4 4"
            />
          </svg>
        </div>
        <p className="text-gray-600">Arrastra y suelta archivos para subir o</p>
        <button className="mt-2 px-4 py-2 bg-blue-500 text-white rounded">
          Examinar
        </button>
        <p className="text-gray-400 mt-2 text-sm">
          Archivos soportados: PDF, PNG, JPEG (máx. 5 MB)
        </p>
      </div>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      {file && (
        <div className="w-full max-w-lg">
          <h2 className="text-lg font-bold mb-2">Archivo seleccionado</h2>
          <ul>
            <li className="flex items-center justify-between mb-2 p-2 border rounded-lg bg-white">
              <div className="flex items-center">
                <span className="mr-2">
                  {getFileTypeIcon(file.file.type)}
                </span>
                <p className="truncate w-40">{file.file.name}</p>
              </div>
              <div className="w-32">
                <ProgressBar progress={file.progress} />
              </div>
              <button
                className="ml-2 text-red-500"
                onClick={() => setFile(null)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </li>
          </ul>
        </div>
      )}
      <button
        className="mt-4 px-4 py-2 bg-green-500 text-white rounded w-full"
        onClick={uploadFile}
      >
        Guardar
      </button>
    </div> */}

<div className="flex flex-col items-center">
  <div className='flex mb-3'>
<div className="  w-1/2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                N° Documento
              </label>
              <div className="flex">
                <input
                  disabled={true}
                  defaultValue={dataUser.MPUced}
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="ml-3  w-1/2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Paciente
              </label>
              <div className="flex">
                <input
                  disabled={true}
                  defaultValue={dataUser.MPNOMC}
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            </div>
      <div
        className="border-dashed border-2 border-gray-400 rounded-lg p-6 text-center cursor-pointer w-80 mb-4"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current.click()}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="hidden"
        />
        <div className="text-blue-500 mb-2">
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 16l-4-4m0 0l4-4m-4 4h18M13 7h4m-2-2v6m0 6v4m0-4h-4m4 0l-4 4m4-4l4 4"
            />
          </svg> */}
          {/* <svg
  xmlns="http://www.w3.org/2000/svg"
  className="h-12 w-12 mx-auto text-blue-500"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M4 4v4c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4m0 16v-4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v4m12-8l-4-4m0 0l-4 4m4-4v12" />
</svg> */}



{/* <svg xmlns="http://www.w3.org/2000/svg"  className="h-12 w-12 mx-auto text-blue-500" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="50" height="50"><path d="m20.096,5.389l-3.485-3.485c-1.228-1.228-2.86-1.904-4.596-1.904h-5.515C4.019,0,2,2.019,2,4.5v15c0,2.481,2.019,4.5,4.5,4.5h11c2.481,0,4.5-2.019,4.5-4.5v-9.515c0-1.736-.676-3.369-1.904-4.596Zm-.707.707c.551.551.97,1.198,1.243,1.904h-5.132c-.827,0-1.5-.673-1.5-1.5V1.368c.706.273,1.353.692,1.904,1.243l3.485,3.485Zm1.611,13.404c0,1.93-1.57,3.5-3.5,3.5H6.5c-1.93,0-3.5-1.57-3.5-3.5V4.5c0-1.93,1.57-3.5,3.5-3.5h5.515c.334,0,.663.03.985.088v5.412c0,1.378,1.122,2.5,2.5,2.5h5.412c.058.322.088.651.088.985v9.515Zm-5.087-5.35c.193.197.189.514-.008.707-.097.095-.224.143-.35.143-.13,0-.259-.05-.357-.15l-2.515-2.57c-.056-.056-.117-.103-.183-.142v7.363c0,.276-.224.5-.5.5s-.5-.224-.5-.5v-7.362c-.066.04-.129.088-.187.146l-2.511,2.566c-.193.198-.509.202-.707.008-.197-.193-.201-.51-.008-.707l2.515-2.57c.384-.384.886-.577,1.388-.58.003,0,.006,0,.009,0,.003,0,.006,0,.009,0,.502.002,1.003.194,1.384.576l2.519,2.574Z"/></svg> */}

<svg xmlns="http://www.w3.org/2000/svg" className="mx-auto text-blue-500" width="24" height="24" viewBox="0 0 24 24"><path d="M10 9h-6l8-9 8 9h-6v11h-4v-11zm11 11v2h-18v-2h-2v4h22v-4h-2z"/></svg>
{/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 21l-8-9h6v-12h4v12h6l-8 9zm9-1v2h-18v-2h-2v4h22v-4h-2z"/></svg> */}
        </div>
        <p className="text-gray-600">Arrastra y suelta archivos para subir o</p>
        <button className="mt-2 px-4 py-2 bg-blue-500 text-white rounded">
          Examinar
        </button>
        <p className="text-gray-400 mt-2 text-sm">
          Archivos soportados: PDF, PNG, JPEG (máx. 5 MB)
        </p>
      </div>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      {file && (
        <div className="w-full max-w-lg">
          <h2 className="text-lg font-bold mb-2">Archivo seleccionado</h2>
          <ul>
            <li className="flex items-center justify-between mb-2 p-2 border rounded-lg bg-white">
              <div className="flex items-center">
                <span className="mr-2">
                  {getFileTypeIcon(file.file.type)}
                </span>
                <p className="truncate w-40">{file.file.name}</p>
              </div>
              <div className="w-32">
                <ProgressBar progress={file.progress} />
              </div>
              <button
                className="ml-2 text-red-500"
                onClick={() => handleClickEliminarArchivo()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </li>
          </ul>
        </div>
      )}
      
    </div>
          

          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              onClick={uploadFile}
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const ProgressBar = ({ progress }) => {
    return (
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className="bg-blue-600 h-2.5 rounded-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    );
  };

export default ModalSubirYDescargarAchivos